export default __webpack_public_path__ + "static/media/locationDark.28af28da.svg";